import React from 'react';

const JS_IE_Edge = () => {
  return (
    <div >
      <h1>JS_IE_Edge</h1>
      <p>Placeholder component for: "JS IE / Edge"</p>
    </div>
  );
};

export default JS_IE_Edge;
